import useProjectNotesQuery from '../project-notes/useQuery';
import useEventNotesQuery from '../event-notes/useQuery';
import useOfferNotesQuery from '../offer-notes/useQuery';
import usePartnerNotesQuery from '../partner-notes/useQuery';
import useEducatorNotesQuery from '../educator-notes/useQuery';
import { PayloadStates } from '@lore/utils';

export default function useQuery(props) {
  const projectNotes = useProjectNotesQuery(props);
  const eventNotes = useEventNotesQuery(props);
  const offerNotes = useOfferNotesQuery(props);
  const partnerNotes = usePartnerNotesQuery(props);
  const educatorNotes = useEducatorNotesQuery(props);

  if (
    projectNotes.state !== PayloadStates.RESOLVED ||
    eventNotes.state !== PayloadStates.RESOLVED ||
    offerNotes.state !== PayloadStates.RESOLVED ||
    partnerNotes.state !== PayloadStates.RESOLVED ||
    educatorNotes.state !== PayloadStates.RESOLVED
  ) {
    return {
      state: PayloadStates.FETCHING,
      data: [],
      meta: undefined
    };
  }

  return {
    state: PayloadStates.RESOLVED,
    data: [].concat(
      projectNotes.data,
      eventNotes.data,
      offerNotes.data,
      partnerNotes.data,
      educatorNotes.data
    ),
    meta: {
      totalCount: (
        (projectNotes.meta?.totalCount || 0) +
        (eventNotes.meta?.totalCount || 0) +
        (offerNotes.meta?.totalCount || 0) +
        (partnerNotes.meta?.totalCount || 0) +
        (educatorNotes.meta?.totalCount || 0)
      )
    }
  };
}
